export default __webpack_public_path__ + "static/media/antitrendelenburg-demo.1d26b033.png";